import React from 'react';
import ServiceHero from '../../components/service/ServiceHero';
import QuoteForm from '../../components/home/QuoteForm';
import ServicesSection from '../../components/home/ServicesSection';
import DiscussionSection from '../../components/home/DiscussionSection';
import Development from '../../components/service/Development';
import ServiceArchitecture from '../../components/service/ServiceArchitecture';
import ProjectsSection from '../../components/home/ProjectsSection';
import TestimonialsSection from '../../components/home/TestimonialsSection';
import CompareQualitySection from '../../components/home/CompareQualitySection';
import ModelsSection from '../../components/home/ModelsSection';
import OnboardingSection from '../../components/home/OnboardingSection';
import BestArchitectureSection from '../../components/home/BestArchitectureSection';
import DesireTechSection from '../../components/home/DesireTechSection';
import IndustriesSection from '../../components/home/IndustriesSection';
import ServiceTrusted from '../../components/service/ServiceTrusted';
import SoftwaresSection from '../../components/home/SoftwaresSection';
import AwardsSection from '../../components/home/AwardsSection';
import FAQSection from '../../components/home/FAQSection';
import BlogsSection from '../../components/home/BlogsSection';
import ContactSection from '../../components/home/ContactSection';

import experiencedImg from '../../assets/img/indus/Experienced team.png';
import techEdgeImg from '../../assets/img/indus/Technological Advantage.png';
import communicationImg from '../../assets/img/indus/Effective Communication.png';
import fasterMarketImg from '../../assets/img/indus/Faster Time to Market.png';
import qualityStandardsImg from '../../assets/img/indus/High-Quality Standards.png';
import bestValueImg from '../../assets/img/indus/Best Value.png';
import step1 from '../../assets/img/OnboardingSection/1.png';
import step2 from '../../assets/img/OnboardingSection/2.png';
import step3 from '../../assets/img/OnboardingSection/3.png';
import step4 from '../../assets/img/OnboardingSection/4.png';

const BimServicePage = () => {
  const bimCoreValues = [
    {
      title: "Deep Expertise",
      desc: "We have a team with professional years of experience in BIM modeling. You are equipped with the USA building codes and standards first, so your projects are correct and compliant from the start.",
      icon: <div className="anim-float"><img src={experiencedImg.src || experiencedImg} alt="Expertise" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /></div>
    },
    {
      title: "Advanced Technology",
      desc: "We implement the currently available BIM details tools. This allows us to develop precise, data-driven models that improve project collaboration and reduce on-site errors. You can visualize your project well before construction.",
      icon: <div className="cog-spin"><img src={techEdgeImg.src || techEdgeImg} alt="Tech" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /></div>
    },
    {
      title: "Cost-Effective Solutions",
      desc: "Our BIM solution saves you significant overhead when you outsource to us. You do not incur the cost of in-house software, hardware, or specialized training licenses. Actually, our services are affordable without compromising on quality.",
      icon: <div className="dollar-float"><img src={bestValueImg.src || bestValueImg} alt="Value" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /></div>
    },
    {
      title: "Faster Turnaround Times",
      desc: "With practical processes in place and your team working more, you can get all your projects done on time. We make sure you don't miss tight deadlines. This keeps the total cost of your project from being delayed at astronomical expense.",
      icon: <div className="anim-float"><img src={fasterMarketImg.src || fasterMarketImg} alt="Speed" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /></div>
    },
    {
      title: "Seamless Collaboration",
      desc: "We fit well into your current team. Consider us as a part of your office. We send you to the point and provide frequent feedback, simplifying the whole process.",
      icon: <div className="chat-bounce"><img src={communicationImg.src || communicationImg} alt="Collaboration" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /></div>
    },
    {
      title: "Scalable Resources",
      desc: "With a small project or a set of large-scale developments underway, our services scale to your specific needs with the minimum of fuss. Of course, this adaptability is an advantage of having adequate backup at every moment.",
      icon: <div className="award-shine"><img src={qualityStandardsImg.src || qualityStandardsImg} alt="Scale" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /></div>
    }
  ];

  const bimProcessSteps = [
    {
      title: "Project Initiation",
      description: "It begins by knowing what your projects need. We compile project objectives and more detailed project inputs to provide a clear roadmap for the BIM model.",
    },
    {
      title: "Design Integration",
      description: "We combine design inputs with different sources such as sketches, CAD drawings, and point cloud data. This produces a single, precise BIM model that enhances coordination and planning.",
    },
    {
      title: "BIM Model Creation",
      description: "Using advanced software, we create high-quality data-based BIM models. All major structural elements are incorporated in these models, including layouts and material specifications.",
    },
    {
      title: "Clash Detection and Resolution",
      description: "Common BIM methods are used to identify and resolve design conflicts. It makes easier the interaction between architectural, structural and MEP elements.",
    },
    {
      title: "Review and Revision",
      description: "We will then review the BIM models and take your comments into consideration. This guarantees that, at the end of the project, it complies with all specifications of the model.",
    },
    {
      title: "Delivery",
      description: "When we provide the BIM model, we give it a complete documentation package. You receive it in the format that plays nicely with your existing workflow. This involves ongoing support and delivery of final models.",
    }
  ];

  return (
    <div className="bim-service-page">
      <ServiceHero
        title={<>Best <span className="text-primary">BIM</span> Drafting & Modeling Services Company</>}
        subtitle="As a leading BIM Outsourcing company, Chudasama Outsourcing provides top-quality BIM Services to architects, real estate developers, engineers, and contractors."
      />
      <QuoteForm />
      <ServiceTrusted />
      <ServicesSection />
      <DiscussionSection
        title={<><span className="text-primary">Need expert Revit</span> BIM architects and engineers?</>}
        subtitle="Access over 100 remote, dedicated BIM professionals trained in US standards. They are ready to improve your project's efficiency right away."
        buttonText="Inquire now"
      />
      <Development />
      <ServiceArchitecture
        title={<>Architectural Revit <span className="text-primary">BIM Modeling</span> Process</>}
        description="We follow a systematic and collaborative BIM process to ensure your projects are accurate, clash-free, and delivered within the promised timeline."
        steps={bimProcessSteps}
      />
      <ProjectsSection />
      <TestimonialsSection />
      <CompareQualitySection
        title={
          <>
            <span className="compare-title-main" style={{ display: 'block' }}>
              Speed, Quality and Affordability of our Point Cloud to BIM
            </span>
            <span className="compare-title-sub text-primary" style={{ display: 'block' }}>
              Services compared to the DIY calculator.
            </span>
          </>
        }
        subtitle="Our Team Of Over 90+ Dedicated Architects And Engineers Provides Expert Scan-To-BIM And Scan-To-CAD Services. We Cater Specifically To Surveyors, Architects, And Engineers Working In The ACS And MEPF Fields, Ensuring Precision And Tailored Solutions For Every Project."
      />
      <ModelsSection />
      <OnboardingSection
        title={<><span className="text-primary">Onboarding simplified:</span> Start your BIM project today</>}
        description="Scan to BIM service company strategic planning and flexible engagement models make starting your project effortless. Here's our seamless process to kick off your architecture BIM solution."
        steps={[
          {
            step: "Step 1",
            title: "Discuss & plan requirements.",
            desc: "Connect with the team and discuss your project use-cases. We will help you educate yourself your organization on defining scope, goals and technical needs for a sound outcome.",
            icon: step1
          },
          {
            step: "Step 2",
            title: "Shortlist Architecture",
            desc: "We will guide you through selecting and assessing the best architecture to meet your goals around scalability, performance and security.",
            icon: step2
          },
          {
            step: "Step 3",
            title: "Finalize your team",
            desc: "We will bring together a team of highly skilled professionals based on your project needs so you have experts in place.",
            icon: step3
          },
          {
            step: "Step 4",
            title: "Onboard the team",
            desc: "We'll help you integrate your new team, ensuring a smooth start with clear roles, goals, and communication channels for project success.",
            icon: step4
          }
        ]}
      />
      <BestArchitectureSection />
      <DesireTechSection
        title={<><span className="text-primary">Ready to discuss</span> your BIM project?</>}
        subtitle="Contact our expert team today and get a free consultation & quote for your BIM services."
        buttonText="Request Free BIM Quote"
      />
      <IndustriesSection
        title={<> <span className="text-primary">Why Choose Us for BIM</span> Revit Modeling Services in the USA?</>}
        subtitle="As one of the best BIM model outsourcing service providers, we can meet all your architectural requirements! Our expert services, delivered by an experienced, trained team of BIM modelers, can offer you end-to-end, scalable, high-end solutions to support your business. These are some more reasons why we could be a perfect partner for your BIM Services."
        coreValues={bimCoreValues}
      />
      <SoftwaresSection />
      <AwardsSection />
      <FAQSection
        title={<><span className="text-primary">Frequently Asked Questions</span> (FAQ) – BIM Modeling Services</>}
        subtitle="Find Fast Answers To The Questions Most Frequently Asked By New Customers Exploring Our Service For The First Time."
        faqs={[
          {
            question: "What is BIM Modeling and how can it benefit my project?",
            answer: "BIM (Building Information Modeling) is a digital representation of your building project. It helps in better visualization, coordination, and management of all architectural, structural, and MEP components, reducing errors and saving time and costs during construction."
          },
          {
            question: "Which software do you use for BIM modeling?",
            answer: "We use industry-standard software such as Revit, AutoCAD, Navisworks, and ArchiCAD. Our team ensures your model is compatible with your project requirements and construction workflow."
          },
          {
            question: "Can you provide BIM models for all types of projects?",
            answer: "Yes, we cater to residential, commercial, and industrial projects. Whether it's a small building or a large infrastructure project, our BIM models are scalable and detailed to meet your project needs."
          },
          {
            question: "How long does it take to create a BIM model?",
            answer: "The timeline depends on the complexity and size of your project. Typically, small projects take 1-6 Days, while larger projects may require 3-15 days. We provide a clear project schedule before starting the work."
          },
          {
            question: "Do you offer support after the BIM model is delivered?",
            answer: "Absolutely. We provide post-delivery support for any modifications, updates, or technical clarifications. Our goal is to ensure your BIM model remains accurate and useful throughout the project lifecycle."
          }
        ]}
      />
      <BlogsSection />
      <ContactSection />

    </div>
  );
};

export default BimServicePage;
